import { useCallback } from 'react';
import TagManager from 'react-gtm-module';
import { useAtomValue } from 'jotai';
import { getCartIdAtom } from 'src/store';
import { useGetCartQuery } from 'src/hooks';

type Props = {
  page: 'Get' | 'Embed' | 'Receive';
  modal:
    | 'Ext Missing Modal'
    | 'Redirection Taking Too Long Modal'
    | 'Unsupported Retailer Modal';
};

export const useOpenItemsInNewTab = ({ page, modal }: Props) => {
  const cartId = useAtomValue(getCartIdAtom);
  const cartQuery = useGetCartQuery({ cartId });

  return useCallback(() => {
    cartQuery.data?.items.forEach((item) => {
      if (!item?.url) {
        return;
      }

      TagManager.dataLayer({
        dataLayer: {
          event: 'Manual Send to Vendor',
          eventCategory: 'engagement',
          eventLabel: `${page} Page (${modal})`,
          eventValue: {
            cartId,
            cartValue: cartQuery.data?.cartTotalPrice,
            cartCCY: cartQuery.data?.cartCCY,
            cartVendor: cartQuery.data?.vendorDisplayName,
          },
        },
      });

      window.open(
        `${item.url}`,
        '_blank',
        'noopener noreferrer',
      );
    });
  }, [cartId, cartQuery.data, page, modal]);
};
